A subdivision of a country such as a state, province, or territory.
